export const GET_USER_LOADING = 'GET_USER_LOADING'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILED = 'GET_USER_FAILED'
export const LOGOUT_USER = 'LOGOUT_USER'